import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var sessionToken = require("../constants/credentials");
var Payment = require("./Payment");
var Parse = require("parse");

/**
 * Contains functions for calling and declaring
 *
 * @class Jobin.CRMNotification
 * @static
 * @hideconstructor
 */

/**
 * Subscribe to crm notifications using live query
 * @method subscribe
 * @name Jobin.CRMNotification.subscribe
 * @returns {Subscription}
 */
export function subscribe() {
  return _subscribe.apply(this, arguments);
}
/**
 * Search crm notifications
 * @method search
 * @name Jobin.CRMNotification.search
 * @param {boolean} read
 * @returns {Array} CRMNotification Parse Objects
 */
function _subscribe() {
  _subscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var agent, subscription;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return new Parse.Query("CRMUser").equalTo("sessionToken", sessionToken.getToken()).first();
        case 2:
          agent = _context.sent;
          _context.next = 5;
          return new Parse.Query("CRMNotification").equalTo("ToAgent", agent).lessThan("Timestamp", new Date()).include(["Job", "FixedInfo", "Transportation", "Payment", "User"]).descending("createdAt").subscribe();
        case 5:
          subscription = _context.sent;
          return _context.abrupt("return", {
            status: "ok",
            result: subscription
          });
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _subscribe.apply(this, arguments);
}
export function search(_x) {
  return _search.apply(this, arguments);
}
/**
 * Mark some notifications as read
 * @method markAsRead
 * @name Jobin.CRMNotification.markAsRead
 * @param {Parse.Object[]} notifications CRMNotifications
 * @returns {Parse.Object[]} the input notifications already modified and saved
 */
function _search() {
  _search = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(read) {
    var agent, query;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return new Parse.Query("CRMUser").equalTo("sessionToken", sessionToken.getToken()).first();
        case 2:
          agent = _context2.sent;
          query = new Parse.Query("CRMNotification").lessThan("Timestamp", new Date()).include(["Job", "FixedInfo", "Transportation", "Payment", "User"]).descending("Timestamp").limit(20);
          if (typeof read == "boolean") query.equalTo("Read", read);
          _context2.prev = 5;
          _context2.next = 8;
          return query.find();
        case 8:
          _context2.t0 = _context2.sent;
          return _context2.abrupt("return", {
            status: "ok",
            result: _context2.t0
          });
        case 12:
          _context2.prev = 12;
          _context2.t1 = _context2["catch"](5);
          console.error(_context2.t1);
          return _context2.abrupt("return", {
            status: "error",
            result: "Algo salió mal al buscar las notificaciones"
          });
        case 16:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[5, 12]]);
  }));
  return _search.apply(this, arguments);
}
export function markAsRead(_x2) {
  return _markAsRead.apply(this, arguments);
}
/**
 * Get user friendly title and description
 * @method getParsedInfo
 * @name Jobin.CRMNotification.getParsedInfo
 * @param {ParseObject} notification CRMNotification
 * @returns {Object} title and description
 */
function _markAsRead() {
  _markAsRead = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(notifications) {
    var i;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          for (i = 0; i < notifications.length; i++) notifications[i].set("Read", true);
          _context3.next = 3;
          return Parse.Object.saveAll(notifications);
        case 3:
          _context3.t0 = _context3.sent;
          return _context3.abrupt("return", {
            status: "ok",
            result: _context3.t0
          });
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _markAsRead.apply(this, arguments);
}
export function getParsedInfo(notification) {
  var title, description, extraInfo;
  switch (notification.get("Type")) {
    //Subida de trabajos
    case "new_job":
      title = "Nuevo servicio pendiente";
      description = "Hay un nuevo servicio pendiente de gestionar.";
      extraInfo = "";
      break;
    case "newDraft":
      title = "Nuevo presupuesto";
      description = "Se ha subido un nuevo presupuesto";
      extraInfo = "";
      break;
    //Deadlines

    case "stillDraft":
      title = "Aviso: No se ha acepato el presupuesto";
      description = "Ha pasado demasiado tiempo desde que se emitió el presupuesto y aun no se ha aceptado";
      extraInfo = "";
      break;
    case "stillNoJober":
      title = "Aviso: Aún no hay jober";
      description = "El servicio ya debería tener un jober asignado";
      extraInfo = "";
      break;
    case "stillNoDate":
      title = "Aviso: Aún no hay cita";
      description = "El servicio ya debería tener una cita asignada";
      extraInfo = "";
      break;
    case "stillNotFinished":
      title = "Aviso: Aún no se ha completado el servicio";
      description = "El servicio ya debería haberse finalizado";
      extraInfo = "";
      break;
    //Acciones en pagos

    case "newPaymentPending":
      {
        var payment = notification.get("Payment");
        var formattedPrice = payment.has("Price") ? (payment.get("Price") * 1.21).toFixed(2) : "0.00";
        title = "Nuevo pago pendiente";
        description = "Se ha enviado un email al usuario con la pasarela de pago o plataforma de financiación";
        extraInfo = "".concat(formattedPrice, " \u20AC mediante ").concat(Payment.formatMethod(payment));
      }
      break;
    case "newPaymentFailed":
      {
        var _payment = notification.get("Payment");
        var _formattedPrice = _payment.has("Price") ? (_payment.get("Price") * 1.21).toFixed(2) : "0.00";
        title = "Fallo en pago";
        description = "El usuario ha intentado pagar pero ha fallado";
        extraInfo = "".concat(_formattedPrice, " \u20AC mediante ").concat(Payment.formatMethod(_payment));
      }
      break;
    //Otros

    default:
      title = "Notificación desconocida";
      description = "Has recibido una notificación que el sistema no reconoce. Tipo: " + notification.get("Type");
      extraInfo = "";
      break;
  }
  return {
    status: "ok",
    result: {
      title: title,
      description: description,
      extraInfo: extraInfo,
      importance: notification.get("Importance")
    }
  };
}